import { InitOptions } from "i18next";

export const LANGS_MAP = {
  enUS: {
    label: "English",
    value: "en-US",
  },
  hiIN: {
    label: "Hindi",
    value: "hi-IN",
  },
  ar: {
    label: "العربية",
    value: "ar",
  },
  es: {
    label: "Spanish",
    value: "es",
  },
  vi: {
    label: "Vietnamese",
    value: "vi",
  },
} as const;

export type TLangsValues = (typeof LANGS_MAP)[keyof typeof LANGS_MAP]["value"];

export const LANGS_VALUES = Object.values(LANGS_MAP).map(
  (value) => value.value,
);

export const LANGS_VALUES_MAP = LANGS_VALUES.reduce(
  (acc, value) => {
    return {
      ...acc,
      [value]: value,
    };
  },
  {} as Record<TLangsValues, TLangsValues>,
);

export type TLangsKeys = keyof typeof LANGS_MAP;
export const NAMESPACES = [
  "common",
  "errors",
  "evaluationDashboardPage",
  "adminDashboardPage",
  "adminCampaignPage",
  "adminWorkFlowPage",
  "adminServicePage",
  "adminCallSummaryPage",
  "sttEngineConfigurationPage",
  "loginPage",
  "manageTemplatePage",
  "piiConfigurationPage",
  "piiEntityPage",
  "piiPatternPage",
  "piiDenyTermPage",
  "evaluationListingPage",
  "evaluationDetailsPage",
  "dataIngestionPage",
  "conversationalTagPage",
  "manageUserPage",
  "onboardUserPage",
  "inviteVerificationPage",
  "pushApiClientsPage",
  "brandingPage",
  "entityScaleRating",
  "agentPerformanceDashboardPage",
  "changePasswordPage",
  "topViolationByCategory",
  "organizationHierarchyPage",
  "metadataConfigurationPage",
  "employeeAttributesPage",
  "employeeManagementPage",
  "campaignPage",
  "servicesPage",
  "employeeToUserVerificationPage",
  "overAllSentimentAnalysisPage",
  "personalizedCoachingInsightsPage",
  "nanoLearningPage",
  "learningHubPage",
  "roleManagementPage",
  "automationRulePage",
  "domainsPage",
  "entityFieldMappingPage",
  "reportsPage",
  "analyticsPage",
  "userConfigurationDashboardPage",
  "customerInsightsPage",
  "teamReportsPage",
  "agentRankingConfigurationPage",
  "aiEngineConfigurationPage",
  "forbidden",
  "selectionCriteriaPage",
] as const;

export type TNamespaces = (typeof NAMESPACES)[number];

export const DEFAULT_INIT_OPTION: InitOptions = {
  // overrides language detection
  fallbackLng: LANGS_MAP.enUS.value,
  // allowed languages
  supportedLngs: LANGS_VALUES,
  // logging
  debug: false,
  ns: NAMESPACES,
  defaultNS: NAMESPACES[0],
  fallbackNS: NAMESPACES[0],
  load: "currentOnly",

  interpolation: {
    escapeValue: false,
    // defaults
    prefix: "{{",
    suffix: "}}",

    format: (value, format, _) => {
      if (value instanceof String) {
        if (format === "uppercase") return value.toUpperCase();
        if (format === "lowercase") return value.toLowerCase();
      }
      return value as string;
    },
  },

  react: {
    useSuspense: false,
  },

  // defaults
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
};
